// src/index.js - Aggiornato per supportare modalità kiosk e Service Worker
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './admin.css';
import './kioskMode.css'; // Aggiungi CSS per modalità kiosk
import KioskRouter from './KioskRouter'; // Usa KioskRouter invece di App
import { allowNextUnload } from './utils/kioskLock';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <KioskRouter />
  </React.StrictMode>
);

// ✅ NUOVO: Registrazione Service Worker per Sistema Cache Automatico
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('✅ Service Worker registrato con successo:', registration);
        
        // Controlla aggiornamenti del Service Worker
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          console.log('🔄 Nuovo Service Worker in installazione');
          
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                console.log('📦 Nuovo Service Worker installato, contenuti aggiornati');
                // Invia messaggio per pulire cache vecchie
                navigator.serviceWorker.controller.postMessage({
                  type: 'CLEAR_OLD_CACHES'
                });
              } else {
                console.log('📦 Service Worker installato per la prima volta');
              }
            }
          });
        });
        
        // Ascolta messaggi dal Service Worker
        navigator.serviceWorker.addEventListener('message', (event) => {
          if (event.data && event.data.type === 'CACHE_UPDATED') {
            console.log('💾 Cache aggiornata dal Service Worker');
          }
        });
      })
      .catch((registrationError) => {
        console.error('❌ Registrazione Service Worker fallita:', registrationError);
      });
  });
  
  // ✅ NUOVO: Gestione eventi Service Worker per cache intelligente
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    console.log('🔄 Service Worker controller cambiato');
    // Ricarica la pagina quando il nuovo SW prende controllo.
    // In modalità kiosk la guardia beforeunload bloccherebbe questo reload:
    // dichiariamo che è voluto, altrimenti i tablet non prenderebbero i deploy.
    allowNextUnload();
    window.location.reload();
  });
  
  // ✅ NUOVO: Controlla periodicamente stato Service Worker
  setInterval(() => {
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        type: 'HEALTH_CHECK'
      });
    }
  }, 30000); // Ogni 30 secondi
  
} else {
  console.warn('⚠️ Service Worker non supportato da questo browser');
}

// ✅ NUOVO: Funzione per forzare aggiornamento Service Worker
window.forceServiceWorkerUpdate = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.update();
        console.log('🔄 Aggiornamento Service Worker forzato');
      });
    });
  }
};

// ✅ NUOVO: Funzione per pulire cache manualmente
window.clearAppCache = async () => {
  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(
      cacheNames.map(cacheName => caches.delete(cacheName))
    );
    console.log('🧹 Cache pulita manualmente');
    
    // Invia messaggio al Service Worker
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        type: 'CLEAR_ALL_CACHES'
      });
    }
  }
};

// ✅ NUOVO: Debug utilities per sviluppo
if (process.env.NODE_ENV === 'development') {
  // Funzioni debug disponibili in console
  window.debugCache = {
    // Mostra tutte le cache
    showCaches: async () => {
      const cacheNames = await caches.keys();
      console.log('📋 Cache disponibili:', cacheNames);
      return cacheNames;
    },
    
    // Mostra contenuto di una cache
    showCacheContent: async (cacheName) => {
      const cache = await caches.open(cacheName);
      const requests = await cache.keys();
      console.log(`📋 Contenuto cache "${cacheName}":`, requests.map(req => req.url));
      return requests;
    },
    
    // Pulisci cache specifica
    clearCache: async (cacheName) => {
      const success = await caches.delete(cacheName);
      console.log(`🧹 Cache "${cacheName}" ${success ? 'pulita' : 'non trovata'}`);
      return success;
    },
    
    // Stato Service Worker
    serviceWorkerStatus: () => {
      const sw = navigator.serviceWorker;
      console.log('📊 Service Worker Status:', {
        supported: 'serviceWorker' in navigator,
        controller: sw.controller?.scriptURL,
        ready: sw.ready,
        registrations: sw.getRegistrations()
      });
    }
  };
  
  console.log('🔧 Debug utilities disponibili in window.debugCache');
}

// ✅ NUOVO: Gestione errori globali per cache
window.addEventListener('error', (event) => {
  // Se l'errore è relativo alla cache, prova a pulirla
  if (event.error && event.error.message.includes('cache')) {
    console.warn('⚠️ Errore cache rilevato, pulizia automatica...');
    window.clearAppCache();
  }
});

// ✅ NUOVO: Gestione eventi di rete per cache intelligente
window.addEventListener('online', () => {
  console.log('🌐 Connessione ripristinata');
  // Forza aggiornamento Service Worker quando torna online
  if (navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'NETWORK_ONLINE'
    });
  }
});

window.addEventListener('offline', () => {
  console.log('📵 Connessione persa');
  // Informa il Service Worker che siamo offline
  if (navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'NETWORK_OFFLINE'
    });
  }
});

// ✅ NUOVO: Prevenzione cache corrotte
window.addEventListener('beforeunload', () => {
  // Salva timestamp di chiusura per rilevare crash
  localStorage.setItem('app_last_close', Date.now().toString());
});

// ✅ NUOVO: Rileva crash e pulisci cache se necessario
window.addEventListener('load', () => {
  const lastClose = localStorage.getItem('app_last_close');
  const now = Date.now();
  
  if (lastClose && (now - parseInt(lastClose)) > 5 * 60 * 1000) {
    // Se sono passati più di 5 minuti dall'ultima chiusura
    // probabilmente c'è stato un crash
    console.log('🔄 Possibile crash rilevato, pulizia cache preventiva...');
    window.clearAppCache();
  }
  
  // Aggiorna timestamp
  localStorage.setItem('app_last_close', now.toString());
});

console.log('🚀 Sistema Cache Automatico inizializzato in index.js');